import { environment } from "@envs/environment";

export type Policy = {
  authority: string;
};

type Policies = {
  [key: string]: Policy;
};

export const SIGN_UP = 'signUp';
export const SIGN_IN = 'signIn';
export const EDIT_PROFILE = 'editProfile';
export const RESET_PASSWORD = 'resetPassword';
export const CHANGESIGNINEMAIL = 'changeSignInEmail';

export const policies: Policies = {
  [SIGN_UP]: {
    authority: `https://${environment.sso.tenant}.b2clogin.com/${environment.sso.tenant}.onmicrosoft.com/B2C_1A_SIGNUP`,
  },
  [SIGN_IN]: {
    authority: `https://${environment.sso.tenant}.b2clogin.com/${environment.sso.tenant}.onmicrosoft.com/B2C_1A_SIGNIN`,
  },
  [EDIT_PROFILE]: {
    authority: `https://${environment.sso.tenant}.b2clogin.com/${environment.sso.tenant}.onmicrosoft.com/B2C_1A_PROFILEEDIT`,
  },
  [CHANGESIGNINEMAIL]: {
    authority: `https://${environment.sso.tenant}.b2clogin.com/${environment.sso.tenant}.onmicrosoft.com/B2C_1A_CHANGESIGNINEMAIL`,
  },
  [RESET_PASSWORD]: {
    authority: `https://${environment.sso.tenant}.b2clogin.com/${environment.sso.tenant}.onmicrosoft.com/B2C_1A_PASSWORDRESET`,
  },
};
